import { render } from "./VsInput.vue?vue&type=template&id=162f8c06"
import script from "./VsInput.vue?vue&type=script&lang=js"
export * from "./VsInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__